import React from 'react'
import { Pokedex as PokedexComponent} from '../../../Components/Player/Pokedex'
import { Flex } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'

export const Pokedex = () => {
    const navigate = useNavigate();
    const isDesktopOrLaptop =  useMediaQuery({ query: '(min-device-width: 1224px)' });
    return (
        <>
            {
                isDesktopOrLaptop 
                ? navigate("/404") 
                : <Flex justify='center' align='center'>
                    <PokedexComponent />
                </Flex>
            }
        </>
    )
}
